/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Intensivecoursessinglechoosen3Inputs */

const de__field_intensivecoursessinglechoosen3 = /** @type {(inputs: _Field_Intensivecoursessinglechoosen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crashkurse (eintägig)`)
};

/**

* @param {_Field_Intensivecoursessinglechoosen3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_intensivecoursessinglechoosen3 = /** @type {((inputs?: _Field_Intensivecoursessinglechoosen3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Intensivecoursessinglechoosen3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_intensivecoursessinglechoosen3(inputs)
});
export { _field_intensivecoursessinglechoosen3 as "_field_intensiveCoursesSingleChoosen" }